<template>
  <div class="riskControlDialog">
    <div class="riskControlDialogContent" :style="`background-image: url(${data.icon});`">
      <div class="content-detail">
        <div class="content2">可借</div>
        <div class="content1 red">{{data.discountValueV2}}元</div>
      </div>
      <div class="animate-tag">平台初审已通过</div>
      <nd-button class="withdraw" @click="handleButtonClick" :class="`caseid-${caseid}`">马上拿钱
        <van-count-down :time="autoJumpTime*10e2" @finish="countDownEnd" v-if="showCountDown" style=" font-size: 0.48rem; color: #FFFFFF;">
          <template #default="timeData">
            ({{timeData.seconds+1}}s)
          </template>
        </van-count-down>
      </nd-button>
    </div>
  </div> 
</template>

<script>
import dayjs from 'dayjs'
export default {
  data () {
    return {
      visible: true,
      showCountDown: false
    }
  },
  props: {
    caseid: {
      type: [String, Number],
      default: ''
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    couponEndTime () {
      return dayjs(this.data.couponEndTime).format('MM月DD日')
    },
    autoJumpTime () {
      return this.data.autoJumpTime || 2
    }
  },
  mounted () {
    if (this.data.autoJump === 'Y') {
      this.showCountDown = true
    }
  },
  methods: {
    open () {
      this.visible = true
    },
    close () {
      this.visible = false
      this.$emit('close')
    },
    countDownEnd () {
      this.$sensors.track('popup_auto_click', { caseid: this.caseid })
      this.visible = false
      this.showCountDown = false
      this.handleButtonClick()
    },
    handleButtonClick () {
      this.$router.push({
        path: '/middle/limit'
      })
    },
    show () {}
  }
}
</script>

<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

.riskControlDialog {
  @keyframes scale {
    to {transform: scale(1.1);}
  }
  .animate-tag{
    position: absolute;
    height: 40px;
    line-height: 40px;
    pointer-events: none;
    background: #FFF56A;
    padding: 0 20px;
    border-radius: 20px 20px 20px 0px;
    left: 55%;
    top: 510px;
    z-index: 9;
    font-size: 24px;
    font-family: PingFangSC;
    color: #7D210B;
    animation: scale .5s infinite alternate;
  }
  .riskControlDialogContent {
    width: 620px;
    height: 750px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    margin: 0 auto;
   
    .content-detail {
      font-family: PingFangSC, PingFang SC;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100%;
      padding-top: 250px;
      color: #333;

      .red {
        color: #FF5434 !important;
      }
      .content1 {
        font-size: 48px;
        font-weight: 500;
      }
      .content2 {
        font-size: 48px;
        font-weight: 500;
      }
      .content3 {
        padding-top: 10px;
        color: #999;
        font-size: 24px;
      }
    }
    
    .withdraw {
        position: absolute;
        top: 540px;
        width: 440px;
        height: 80px;
        left: 50%;
        transform: translateX(-50%);
        font-size: 36px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
        line-height: 50px;
    }
  }
}
</style>